import { useState, useEffect } from "react";
import { uid, T, mono, MONTHS_TR } from "./utils";
import { supabase } from "./supabase";

const CATEGORIES = ["Film","BTS","Festival","Duyuru","Alıntı","Ekip","Diğer"];
const CAT_DOT = {"Film":"#4a6fa5","BTS":"#4a90a4","Festival":"#5a8a5a","Duyuru":"#e4572e","Alıntı":"#9b7ec8","Ekip":"#c9843a","Diğer":"#888"};
const DAYS_TR = ["Pzt","Sal","Çar","Per","Cum","Cmt","Paz"];

function getDays(y,m){return new Date(y,m+1,0).getDate();}
function getFirstDay(y,m){return (new Date(y,m,1).getDay()+6)%7;}

export function SocialView() {
  const now = new Date();
  const [posts,setPosts]=useState([]);
  const [projects,setProjects]=useState([]);
  const [loading,setLoading]=useState(true);
  const [calYear,setCalYear]=useState(now.getFullYear());
  const [calMonth,setCalMonth]=useState(now.getMonth());
  const [selDay,setSelDay]=useState(null);
  const [view,setView]=useState("calendar");
  const [form,setForm]=useState({caption:"",category:"Film",visual:"",date:"",time:"12:00",status:"Taslak",project:"",idea:"",image_path:""});
  const [showForm,setShowForm]=useState(false);
  const [uploading,setUploading]=useState(false);
  const [imagePreview,setImagePreview]=useState(null);

  useEffect(()=>{load();},[]);// eslint-disable-line

  async function load() {
    const [{data:p},{data:pr}]=await Promise.all([
      supabase.from("social_posts").select("*").order("date"),
      supabase.from("projects").select("id,title,kind,phase").order("title"),
    ]);
    setPosts(p||[]);
    setProjects(pr||[]);
    setLoading(false);
  }

  // Filtered projects: no Değerlendirilecek, alphabetical
  const selectorProjects=[...projects]
    .filter(p=>p.phase!=="Değerlendirilecek")
    .sort((a,b)=>a.title.localeCompare(b.title,"tr"));

  async function addPost() {
    if(!form.caption||!form.date) return;
    const np={id:uid(),...form};
    setPosts(p=>[...p,np]);
    setForm(f=>({...f,caption:"",visual:""}));
    setShowForm(false);
    await supabase.from("social_posts").insert(np);
  }

  async function removePost(id){
    const post = posts.find(p=>p.id===id);
    if(post?.image_path){
      await supabase.storage.from("social-images").remove([post.image_path]);
    }
    setPosts(p=>p.filter(x=>x.id!==id));
    await supabase.from("social_posts").delete().eq("id",id);
  }

  async function uploadImage(file) {
    if(!file) return;
    setUploading(true);
    const ext = file.name.split(".").pop();
    const path = `${uid()}.${ext}`;
    const { error } = await supabase.storage.from("social-images").upload(path, file);
    if(!error) {
      const { data } = supabase.storage.from("social-images").getPublicUrl(path);
      setForm(f=>({...f,visual:data.publicUrl,image_path:path}));
      setImagePreview(data.publicUrl);
      // Notify Burak
      try {
        await fetch("/api/notify-upload", {
          method:"POST",
          headers:{"Content-Type":"application/json"},
          body:JSON.stringify({
            imageUrl: data.publicUrl,
            caption: form.caption||"",
            category: form.category||"",
            date: form.date||"",
          }),
        });
      } catch(e) { console.error("Bildirim gönderilemedi:", e); }
    }
    setUploading(false);
  }
  async function updateStatus(id,status){setPosts(p=>p.map(x=>x.id===id?{...x,status}:x));await supabase.from("social_posts").update({status}).eq("id",id);}
  async function updateFeedback(id, feedback, feedbackImage, caption, postDate) {
    setPosts(p=>p.map(x=>x.id===id?{...x,feedback,feedback_image:feedbackImage}:x));
    await supabase.from("social_posts").update({feedback,feedback_image:feedbackImage}).eq("id",id);
    if (feedback) {
      try {
        await fetch("/api/send-feedback", {
          method:"POST",
          headers:{"Content-Type":"application/json"},
          body:JSON.stringify({caption, feedback, feedbackImage, postDate}),
        });
      } catch(e) { console.error("Mail gönderilemedi:", e); }
    }
  }

  const todayStr=`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-${String(now.getDate()).padStart(2,"0")}`;
  const selDayStr=selDay?`${calYear}-${String(calMonth+1).padStart(2,"0")}-${String(selDay).padStart(2,"0")}`:null;
  const postsOnDay=(y,m,d)=>{const s=`${y}-${String(m+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`;return posts.filter(p=>p.date===s);};
  const selDayPosts=selDay?postsOnDay(calYear,calMonth,selDay):[];
  const daysInMonth=getDays(calYear,calMonth);
  const firstDay=getFirstDay(calYear,calMonth);
  const prevMonth=()=>{if(calMonth===0){setCalYear(y=>y-1);setCalMonth(11);}else setCalMonth(m=>m-1);};
  const nextMonth=()=>{if(calMonth===11){setCalYear(y=>y+1);setCalMonth(0);}else setCalMonth(m=>m+1);};

  if(loading) return <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{...mono,color:T.mute}}>Loading</span></div>;

  return (
    <div style={{display:"flex",flex:1,overflow:"hidden"}}>
      {/* Sidebar */}
      <div style={{width:180,borderRight:`1px solid ${T.border}`,padding:"28px 0",flexShrink:0,background:T.bg}}>
        <div style={{padding:"0 20px 10px",...mono,fontSize:9,color:T.mute}}>Görünüm</div>
        {[{k:"calendar",l:"Takvim"},{k:"list",l:"Liste"}].map(v=>(
          <div key={v.k} onClick={()=>setView(v.k)} style={{padding:"9px 20px",cursor:"pointer",borderLeft:view===v.k?`2px solid ${T.accent}`:"2px solid transparent"}}>
            <span style={{fontSize:13,fontWeight:view===v.k?500:400,color:view===v.k?T.ink:T.mute}}>{v.l}</span>
          </div>
        ))}
        <div style={{padding:"16px 20px 8px",...mono,fontSize:9,color:T.mute}}>Kategoriler</div>
        {CATEGORIES.map(c=>(
          <div key={c} style={{padding:"5px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div style={{display:"flex",alignItems:"center",gap:7}}>
              <span style={{width:5,height:5,borderRadius:"50%",background:CAT_DOT[c],flexShrink:0}}/>
              <span style={{fontSize:12,color:T.mute}}>{c}</span>
            </div>
            {posts.filter(p=>p.category===c).length>0&&<span style={{...mono,fontSize:9,color:T.mute}}>{posts.filter(p=>p.category===c).length}</span>}
          </div>
        ))}
        <div style={{padding:"14px 20px 0",borderTop:`1px solid ${T.border}`,marginTop:10}}>
          <div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>Toplam</div>
          <div style={{fontSize:20,fontWeight:600,letterSpacing:"-0.02em"}}>{posts.length}</div>
          <div style={{...mono,fontSize:9,color:"#2d7a2d",marginTop:2}}>{posts.filter(p=>p.status==="Yayınlandı").length} yayınlandı</div>
          <div style={{...mono,fontSize:9,color:"#c9843a"}}>{posts.filter(p=>p.status==="Planlandı").length} planlandı</div>
        </div>
      </div>

      {/* Main */}
      <div style={{flex:1,overflowY:"auto",padding:"28px 32px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:20,paddingBottom:14,borderBottom:`1px solid ${T.border}`}}>
          <span style={{fontSize:22,fontWeight:600,letterSpacing:"-0.02em"}}>Instagram</span>
          <button onClick={()=>{setForm(f=>({...f,date:selDayStr||todayStr}));setShowForm(true);}} style={{background:T.ink,color:T.bg,border:"none",borderRadius:2,padding:"6px 14px",fontSize:12,fontWeight:500,cursor:"pointer"}}>+ Post Ekle</button>
        </div>

        {/* Add form */}
        {showForm&&(
          <div style={{background:"#fff",border:`1px solid ${T.border}`,borderRadius:3,padding:"20px",marginBottom:24}}>
            <div style={{...mono,fontSize:9,color:T.mute,marginBottom:14}}>Yeni Post</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
              <div><div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>TARİH</div><input type="date" value={form.date} onChange={e=>setForm(f=>({...f,date:e.target.value}))} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"7px 10px",fontSize:12,fontFamily:"'Inter',sans-serif"}}/></div>
              <div><div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>SAAT</div><input type="time" value={form.time} onChange={e=>setForm(f=>({...f,time:e.target.value}))} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"7px 10px",fontSize:12,fontFamily:"'Inter',sans-serif"}}/></div>
              <div><div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>KATEGORİ</div><select value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"7px 10px",fontSize:12,fontFamily:"'Inter',sans-serif"}}>{CATEGORIES.map(c=><option key={c}>{c}</option>)}</select></div>
              <div><div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>DURUM</div><select value={form.status} onChange={e=>setForm(f=>({...f,status:e.target.value}))} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"7px 10px",fontSize:12,fontFamily:"'Inter',sans-serif"}}>{["Taslak","Planlandı","Yayınlandı"].map(s=><option key={s}>{s}</option>)}</select></div>
              <div style={{gridColumn:"1/-1"}}>
                <div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>PROJE (opsiyonel)</div>
                <select value={form.project} onChange={e=>setForm(f=>({...f,project:e.target.value}))} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"7px 10px",fontSize:12,fontFamily:"'Inter',sans-serif"}}>
                  <option value="">— ETC. (proje yok) —</option>
                  {selectorProjects.map(p=><option key={p.id} value={p.title}>{p.title}</option>)}
                </select>
              </div>
            </div>
            <div style={{marginBottom:10}}>
              <div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>GÖRSEL</div>
              <label style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",border:`2px dashed ${T.border}`,borderRadius:3,cursor:"pointer",background:T.bg}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent} onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                {imagePreview
                  ? <img src={imagePreview} alt="preview" style={{width:60,height:60,objectFit:"cover",borderRadius:2}}/>
                  : <span style={{fontSize:24}}>📷</span>}
                <div>
                  <div style={{fontSize:12,color:T.ink,fontWeight:500}}>{uploading?"Yükleniyor…":imagePreview?"Görsel seçildi · değiştirmek için tıkla":"Görsel yükle"}</div>
                  <div style={{...mono,fontSize:9,color:T.mute}}>JPG, PNG, GIF</div>
                </div>
                <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>uploadImage(e.target.files[0])}/>
              </label>
            </div>
            <div style={{marginBottom:14}}><div style={{...mono,fontSize:9,color:T.mute,marginBottom:4}}>CAPTION</div><textarea value={form.caption} onChange={e=>setForm(f=>({...f,caption:e.target.value}))} rows={3} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,padding:"8px 10px",fontSize:12,fontFamily:"'Inter',sans-serif",resize:"vertical"}}/></div>
            <div style={{marginBottom:14}}>
              <div style={{...mono,fontSize:9,color:"#4a6fa5",marginBottom:4}}>FİKİR (görsel yönlendirme)</div>
              <textarea value={form.idea||""} onChange={e=>setForm(f=>({...f,idea:e.target.value}))} rows={2} placeholder="Görseli hazırlayacak kişiye içerik notu…" style={{width:"100%",background:"#eaf0fa",border:"1px solid #a8c8f0",borderRadius:2,padding:"8px 10px",fontSize:12,fontFamily:"'Inter',sans-serif",resize:"vertical",color:"#185FA5"}}/>
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={addPost} style={{background:T.ink,color:"#fff",border:"none",borderRadius:2,padding:"7px 18px",fontSize:12,cursor:"pointer",fontWeight:500}}>Kaydet</button>
              <button onClick={()=>{setShowForm(false);setImagePreview(null);}} style={{background:"none",border:`1px solid ${T.border}`,color:T.mute,borderRadius:2,padding:"7px 14px",fontSize:12,cursor:"pointer"}}>İptal</button>
            </div>
          </div>
        )}

        {/* Calendar */}
        {view==="calendar"&&(
          <div>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
              <button onClick={prevMonth} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"4px 10px",cursor:"pointer",fontSize:12,color:T.mute}}>←</button>
              <span style={{fontSize:15,fontWeight:500,minWidth:160}}>{MONTHS_TR[calMonth]} {calYear}</span>
              <button onClick={nextMonth} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"4px 10px",cursor:"pointer",fontSize:12,color:T.mute}}>→</button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:3}}>
              {DAYS_TR.map(d=><div key={d} style={{...mono,fontSize:9,color:T.mute,textAlign:"center",padding:"3px 0"}}>{d}</div>)}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
              {Array.from({length:firstDay}).map((_,i)=><div key={"e"+i}/>)}
              {Array.from({length:daysInMonth},(_,i)=>i+1).map(day=>{
                const dp=postsOnDay(calYear,calMonth,day);
                const ds=`${calYear}-${String(calMonth+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
                const isToday=ds===todayStr; const isSel=selDay===day;
                const post=dp[0];
                return (
                  <div key={day} onClick={()=>setSelDay(isSel?null:day)}
                    style={{background:isSel?"#f0ece6":isToday?"#fff8f5":"#fff",border:`1px solid ${isSel?T.accent:isToday?T.accent+"44":T.border}`,borderRadius:2,padding:"5px 6px",minHeight:68,cursor:"pointer",overflow:"hidden"}}
                    onMouseEnter={e=>{if(!isSel)e.currentTarget.style.background="#faf6f2";}}
                    onMouseLeave={e=>{if(!isSel)e.currentTarget.style.background=isToday?"#fff8f5":"#fff";}}>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:3}}>
                      <span style={{fontSize:11,fontWeight:isToday?700:400,color:isToday?T.accent:T.ink}}>{day}</span>
                      {post&&<span style={{width:5,height:5,borderRadius:"50%",background:CAT_DOT[post.category],flexShrink:0}}/>}{post?.idea&&<span style={{width:5,height:5,borderRadius:"50%",background:"#4a6fa5",flexShrink:0}}/>}
                    </div>
                    {post&&(
                      <div>
                        {post.visual&&post.visual.startsWith("http")&&(
                          <img src={post.visual} alt="" style={{width:"100%",height:36,objectFit:"cover",borderRadius:1,marginBottom:2}}/>
                        )}
                        <div style={{fontSize:9,color:T.mute,lineHeight:1.4,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>
                          {post.caption}
                        </div>
                        {post.idea&&<div style={{fontSize:8,color:"#4a6fa5",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>💡 {post.idea}</div>}
                      </div>
                    )}
                    {dp.length>1&&<div style={{...mono,fontSize:8,color:T.mute,marginTop:2}}>+{dp.length-1}</div>}
                  </div>
                );
              })}
            </div>
            {selDay&&(
              <div style={{marginTop:14,border:`1px solid ${T.border}`,borderRadius:3,padding:"14px 16px",background:"#fff"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                  <span style={{fontSize:14,fontWeight:500}}>{selDay} {MONTHS_TR[calMonth]}</span>
                  <button onClick={()=>{setForm(f=>({...f,date:selDayStr}));setShowForm(true);}} style={{background:"none",border:`1px solid ${T.border}`,color:T.mute,borderRadius:2,padding:"4px 10px",fontSize:11,cursor:"pointer"}}>+ Post Ekle</button>
                </div>
                {selDayPosts.length===0?<div style={{...mono,color:T.mute,fontSize:10}}>Post yok.</div>:selDayPosts.map(p=><PostRow key={p.id} post={p} onRemove={removePost} onStatus={updateStatus} onFeedback={(id,fb,fbImg)=>updateFeedback(id,fb,fbImg,p.caption,p.date)}/>)}
              </div>
            )}
          </div>
        )}

        {/* List */}
        {view==="list"&&(
          <div>
            {posts.length===0
              ?<div style={{...mono,color:T.mute,padding:"40px 0"}}>Henüz post yok.</div>
              :<div style={{border:`1px solid ${T.border}`,borderRadius:2,overflow:"hidden"}}>
                <div style={{display:"grid",gridTemplateColumns:"80px 60px 100px 1fr 90px 80px 24px",padding:"8px 14px",background:T.bg,borderBottom:`1px solid ${T.border}`}}>
                  {["Tarih","Saat","Proje","Caption","Kategori","Durum",""].map((h,i)=><span key={i} style={{...mono,fontSize:9,color:T.mute}}>{h}</span>)}
                </div>
                {[...posts].sort((a,b)=>a.date.localeCompare(b.date)).map((p,i)=>(
                  <div key={p.id} style={{display:"grid",gridTemplateColumns:"80px 60px 100px 1fr 90px 80px 24px",padding:"10px 14px",borderBottom:`1px solid ${T.borderLight}`,alignItems:"center",background:i%2===0?"#fff":T.bg}}
                    onMouseEnter={ev=>ev.currentTarget.style.background="#f0ece6"} onMouseLeave={ev=>ev.currentTarget.style.background=i%2===0?"#fff":T.bg}>
                    <span style={{...mono,fontSize:10,color:T.mute}}>{p.date}</span>
                    <span style={{...mono,fontSize:10,color:T.mute}}>{p.time}</span>
                    <span style={{fontSize:11,color:T.mute,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.project||"—"}</span>
                    <span style={{fontSize:12,color:T.ink,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.caption}</span>
                    <div style={{display:"flex",alignItems:"center",gap:5}}>
                      <span style={{width:5,height:5,borderRadius:"50%",background:CAT_DOT[p.category],flexShrink:0}}/>
                      <span style={{...mono,fontSize:9,color:T.mute}}>{p.category}</span>
                    </div>
                    <select value={p.status} onChange={e=>updateStatus(p.id,e.target.value)} style={{...mono,fontSize:9,background:"none",border:"none",color:p.status==="Yayınlandı"?"#2d7a2d":p.status==="Planlandı"?"#c9843a":T.mute,cursor:"pointer",fontFamily:"'JetBrains Mono',monospace"}}>
                      {["Taslak","Planlandı","Yayınlandı"].map(s=><option key={s}>{s}</option>)}
                    </select>
                    <button onClick={()=>removePost(p.id)} style={{background:"none",border:"none",color:"#c0392b",fontSize:14,cursor:"pointer",opacity:0.3,padding:0}} onMouseEnter={ev=>ev.currentTarget.style.opacity="1"} onMouseLeave={ev=>ev.currentTarget.style.opacity="0.3"}>×</button>
                  </div>
                ))}
              </div>}
          </div>
        )}
      </div>
    </div>
  );
}

function PostRow({post,onRemove,onStatus,onFeedback}) {
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackVal, setFeedbackVal] = useState(post.feedback||"");
  const [feedbackImage, setFeedbackImage] = useState(post.feedback_image||"");
  const [uploadingFb, setUploadingFb] = useState(false);

  async function uploadFeedbackImage(file) {
    if(!file) return;
    setUploadingFb(true);
    const ext = file.name.split(".").pop();
    const path = `feedback_${uid()}.${ext}`;
    const { error } = await supabase.storage.from("social-images").upload(path, file);
    if(!error) {
      const { data } = supabase.storage.from("social-images").getPublicUrl(path);
      setFeedbackImage(data.publicUrl);
    }
    setUploadingFb(false);
  }

  function saveFeedback() {
    onFeedback(post.id, feedbackVal, feedbackImage);
    setShowFeedback(false);
  }

  return (
    <div style={{borderBottom:`1px solid ${T.borderLight}`,paddingBottom:8,marginBottom:4}}>
      <div style={{display:"flex",gap:10,alignItems:"flex-start",padding:"9px 0"}}>
        {/* Thumbnail */}
        {post.visual&&post.visual.startsWith("http")
          ? <img src={post.visual} alt="" style={{width:52,height:52,objectFit:"cover",borderRadius:2,flexShrink:0}}/>
          : <div style={{width:52,height:52,background:T.bg,border:`1px solid ${T.border}`,borderRadius:2,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:20}}>📷</span></div>
        }
        <div style={{display:"flex",alignItems:"center",gap:5,flexShrink:0,paddingTop:2}}>
          <span style={{width:5,height:5,borderRadius:"50%",background:CAT_DOT[post.category]}}/>
          <span style={{...mono,fontSize:9,color:T.mute}}>{post.time}</span>
        </div>
        <div style={{flex:1,minWidth:0}}>
          {post.project&&<div style={{...mono,fontSize:9,color:T.accent,marginBottom:2}}>{post.project}</div>}
          <div style={{fontSize:12,color:T.ink,marginBottom:2,lineHeight:1.4}}>{post.caption}</div>
          {post.idea&&<div style={{fontSize:11,color:"#4a6fa5",marginTop:3}}>💡 {post.idea}</div>}
          {post.feedback&&(
            <div style={{fontSize:11,color:"#c9843a",marginTop:3,background:"#fdf3e3",padding:"6px 8px",borderRadius:2,border:"1px solid #f5d78e"}}>
              <div>💬 {post.feedback}</div>
              {post.feedback_image&&<img src={post.feedback_image} alt="feedback" style={{width:"100%",maxWidth:200,borderRadius:2,marginTop:6,display:"block"}}/>}
            </div>
          )}
        </div>
        <div style={{display:"flex",gap:4,alignItems:"center",flexShrink:0}}>
          <button onClick={()=>setShowFeedback(s=>!s)} style={{...mono,fontSize:8,background:post.feedback?"#fdf3e3":"none",border:`1px solid ${post.feedback?"#f5d78e":T.border}`,borderRadius:2,padding:"2px 7px",cursor:"pointer",color:post.feedback?"#c9843a":T.mute}}>
            {post.feedback?"düzenle":"feedback"}
          </button>
          <select value={post.status} onChange={e=>onStatus(post.id,e.target.value)} style={{...mono,fontSize:9,background:"none",border:`1px solid ${T.border}`,borderRadius:2,padding:"2px 6px",color:post.status==="Yayınlandı"?"#2d7a2d":post.status==="Planlandı"?"#c9843a":T.mute,cursor:"pointer",fontFamily:"'JetBrains Mono',monospace"}}>
            {["Taslak","Planlandı","Yayınlandı"].map(s=><option key={s}>{s}</option>)}
          </select>
          <button onClick={()=>onRemove(post.id)} style={{background:"none",border:"none",color:"#c0392b",fontSize:13,cursor:"pointer",opacity:0.4}} onMouseEnter={e=>e.currentTarget.style.opacity="1"} onMouseLeave={e=>e.currentTarget.style.opacity="0.4"}>×</button>
        </div>
      </div>
      {showFeedback&&(
        <div style={{paddingLeft:62,paddingBottom:4}}>
          <textarea value={feedbackVal} onChange={e=>setFeedbackVal(e.target.value)} rows={2}
            placeholder="Feedback yaz…"
            style={{width:"100%",background:"#fdf3e3",border:"1px solid #f5d78e",borderRadius:2,padding:"7px 10px",fontSize:12,fontFamily:"'Inter',sans-serif",resize:"none",outline:"none",color:T.ink,marginBottom:6}}/>
          <label style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"1px dashed #f5d78e",borderRadius:2,cursor:"pointer",background:"#fffaf0",marginBottom:6}}>
            {feedbackImage
              ? <img src={feedbackImage} alt="preview" style={{width:40,height:40,objectFit:"cover",borderRadius:2}}/>
              : <span style={{fontSize:16}}>🖼️</span>}
            <span style={{fontSize:11,color:"#c9843a"}}>{uploadingFb?"Yükleniyor…":feedbackImage?"Görsel seçildi":"Görsel ekle (opsiyonel)"}</span>
            <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>uploadFeedbackImage(e.target.files[0])}/>
          </label>
          <div style={{display:"flex",gap:6}}>
            <button onClick={saveFeedback} style={{background:"#c9843a",color:"#fff",border:"none",borderRadius:2,padding:"5px 14px",fontSize:11,cursor:"pointer",fontWeight:500}}>Kaydet</button>
            <button onClick={()=>setShowFeedback(false)} style={{background:"none",border:`1px solid ${T.border}`,color:T.mute,borderRadius:2,padding:"5px 10px",fontSize:11,cursor:"pointer"}}>İptal</button>
          </div>
        </div>
      )}
    </div>
  );
}
